import { CeaseCategory, CeaseRequestType, CeaseSubCategory } from '../types/cease';

export const getCategoryPairFromRequestType = (
  requestType: CeaseRequestType | '' | null | undefined
): { category: CeaseCategory; subCategory: CeaseSubCategory } => {
  if (requestType === CeaseRequestType.CeaseQuote) {
    return {
      category: CeaseCategory.Quote,
      subCategory: CeaseSubCategory.Customer,
    };
  }

  return {
    category: CeaseCategory.CeaseService,
    subCategory: CeaseSubCategory.HardCease,
  };
};

export const getRequestTypeFromCategory = (
  category?: string,
  subCategory?: string
): CeaseRequestType => {
  if (category === CeaseCategory.Quote && subCategory === CeaseSubCategory.Customer) {
    return CeaseRequestType.CeaseQuote;
  }

  if (category === CeaseCategory.CeaseService && subCategory === CeaseSubCategory.HardCease) {
    return CeaseRequestType.CeaseRequest;
  }

  return CeaseRequestType.CeaseRequest;
};

export const getTypeLabelFromCategory = (category?: string, subCategory?: string): string => {
  return getRequestTypeFromCategory(category, subCategory);
};
